import React from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { arePropertyRatesLoading } from 'selectors/offerPage/offerPageSelectors'
import useCheapestPropertyPricing from 'hooks/OfferPage/useCheapestPropertyPricing'
import _BaseHotelFlightsToggleButton from './_BaseHotelFlightsToggleButton'
import { preventRenderWithOpenFilter } from 'lib/offer/offerPageUtil'

interface Props {
  offer: App.HotelOffer;
  isLoading: boolean;
}

function SinglePropertyHotelFlightsToggleButton(props: Props) {
  const {
    offer,
    isLoading,
  } = props

  /************************************************************************************************/
  /* STOP! Do not add any more hooks for deriving packages/rooms or options/rates to this         */
  /* component! This logic is being refactored out into selectors! If you _need_ to add new       */
  /* logic, speak to Xiao or Robert.                                                              */
  /************************************************************************************************/

  const [
    pricing,
    memberPricing,
    pricingWithFlights,
    memberPricingWithFlights,
  ] = useCheapestPropertyPricing()

  const hotelPrice = pricing?.price ?? 0
  const hotelMemberPrice = memberPricing?.price ?? 0
  const hotelFlightPrice = memberPricingWithFlights?.price ?? pricingWithFlights?.price ?? 0

  // Only show LuxPlus+ badging if the member price is _better_ than the non-member price.
  const showMemberPrice = !!hotelMemberPrice && hotelMemberPrice < hotelPrice
  const hotelTotalPrice = showMemberPrice ? hotelMemberPrice : hotelPrice

  // TODO: Checking these LPC offer flags isn't appropriate if we're dealing with an LPP rate.
  const flightsAvailable = offer.offerFlightsEnabled && !offer.flightCacheDisabled

  return <_BaseHotelFlightsToggleButton
    flightsAvailable={flightsAvailable}
    isMemberPrice={showMemberPrice}
    hotelTotalPrice={hotelTotalPrice}
    hotelFlightTotalPrice={hotelTotalPrice !== hotelFlightPrice ? hotelFlightPrice : undefined}
    pricesLoading={isLoading}
  />
}

export default withOfferPageAndReduxState((state, appState) => ({
  offer: state.offer as App.HotelOffer,
  isLoading: arePropertyRatesLoading(state, appState),
  open: !!state.activeFilter,
}), SinglePropertyHotelFlightsToggleButton, preventRenderWithOpenFilter)
